<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.native="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Configurações</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click.native="dialog = false">Fechar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-list three-line subheader>
          <v-subheader>Controle do usuário</v-subheader>
          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title>Colaborar com fotos</v-list-tile-title>
              <v-list-tile-sub-title>Enviar fotos de uma determinada árvore a Embrapa para publicação no Arbopasto</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title>E-mail</v-list-tile-title>
              <v-list-tile-sub-title>Receba em primeira mão, e com prioridade, os conteúdos do Arbopasto no e-mail.</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-divider></v-divider>
        <v-list three-line subheader>
          <v-subheader>Geral</v-subheader>
          <v-list-tile avatar>
            <v-list-tile-action>
              <v-checkbox></v-checkbox>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Notificações</v-list-tile-title>
              <v-list-tile-sub-title>Notifique-me sobre atualizações do aplicativo</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile avatar>
            <v-list-tile-action>
              <v-checkbox></v-checkbox>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Sincronização</v-list-tile-title>
              <v-list-tile-sub-title>Sincronizar automaticamente e baixar as árvores de forma automática</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title>Versão</v-list-tile-title>
              <v-list-tile-sub-title>0.5.8-beta</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import base from '../contracts/tree.json'

export default {
  data () {
    return {
      dialog: false,
      app: base
    }
  },
  methods: {
    show (app) {
      console.log('show: ' + app)
      this.app = app
      this.dialog = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Settings.vue